import React from 'react';

export const cpcVaultingCashReplenishment = [
  {
    path: '/vaulting',
    component: React.lazy(() => import('./listing')),
  },
  {
    path: '/vaulting/add',
    component: React.lazy(() => import('./add')),
  },
  {
    path: '/vaulting/overview',
    component: React.lazy(() => import('./overview')),
  },
];
